import React, { useEffect, useRef } from "react";
import styles from "./OrchestraMembersDisplay.module.css";
import { Section } from "./Section";
import { useTranslation } from "react-i18next";
//usual photos
// import abialon from "../../assets/musicians/abialon.webp";
// import bsolarz from "../../assets/musicians/bsolarz.webp";
// import glipka from "../../assets/musicians/glipka.webp";
// import imentel from "../../assets/musicians/imentel.webp";
// import jbielak from "../../assets/musicians/jbielak.webp";
// import jkwasniewska from "../../assets/musicians/jkwasniewska.webp";
// import mpelcel from "../../assets/musicians/mpelcel.webp";
// import msularz from "../../assets/musicians/msularz.webp";
// import nfirek from "../../assets/musicians/nfirek.webp";
// import pkornas from "../../assets/musicians/pkornas.webp";
// import tslonina from "../../assets/musicians/tslonina.webp";
// import asyc from "../../assets/musicians/asyc.webp";
// import iwarzecha from "../../assets/musicians/iwarzecha.webp";
// import jbiernat from "../../assets/musicians/jbiernat.webp";
// import mkowalcze from "../../assets/musicians/mkowalcze.webp";
// import zrabska from "../../assets/musicians/zrabska.webp";
// import msabura from "../../assets/musicians/msabura.webp";
// import sjakobik from "../../assets/musicians/sjakobik.webp";

const orchestraSections: Section[] = [
  {
    name: "conductor",
    members: [{ name: "Łukasz Wicher", instruments: [], photo: "" }],
  },
  {
    name: "violins",
    members: [
      { name: "Patrycja Kornaś", instruments: ["violin"], photo: "" },
      { name: "Iga Mentel", instruments: ["violin"], photo: "" },
      { name: "Emilia Główka", instruments: ["violin"], photo: "" },
      {
        name: "Bartłomiej Solarz",
        instruments: ["violin", "rapper"],
        photo: "",
      },
      { name: "Alicja Gałka", instruments: ["violin"], photo: "" },
      { name: "Amelia Syc", instruments: ["violin"], photo: "" },
      { name: "Antonina Malińska", instruments: ["violin"], photo: "" },
      { name: "Amelia Wójtowicz", instruments: ["violin"], photo: "" },
      { name: "Sara Jakóbik", instruments: ["violin"], photo: "" },
      { name: "Martyna Sabura", instruments: ["violin"], photo: "" },
      { name: "Lilianna Cieślak", instruments: ["violin"], photo: "" },
      { name: "Karolina Wilczak", instruments: ["violin"], photo: "" },
      { name: "Julia Biernat", instruments: ["violin"], photo: "" },
      { name: "Zuzanna Rabska", instruments: ["violin"], photo: "" },
      { name: "Łucja Kasiniak", instruments: ["violin"], photo: "" },
      { name: "Katarzyna Mołocznik", instruments: ["vocal"], photo: "" },
    ],
  },
  {
    name: "cellos",
    members: [
      { name: "Patrycja Kosek", instruments: ["cello"], photo: "" },
      { name: "Hania Klimowska", instruments: ["cello"], photo: "" },
      { name: "Ida Warzęcha", instruments: ["cello"], photo: "" },
    ],
  },
  {
    name: "brassInstruments",
    members: [
      { name: "Weronika Jucha", instruments: ["tenorSaxophone"], photo: "" },
      { name: "Janusz Gałka", instruments: ["tenorSaxophone"], photo: "" },
      { name: "Natalia Hanus", instruments: ["altoSaxophone"], photo: "" },
      { name: "Gabriela Lipka", instruments: ["altoSaxophone"], photo: "" },
      { name: "Dawid Dittmajer", instruments: ["altoSaxophone"], photo: "" },
      {
        name: "Mateusz Pelcel",
        instruments: ["altoSaxophone"],
        photo: "",
      },
      { name: "Marcel Sularz", instruments: ["altoSaxophone"], photo: "" },
      {
        name: "Tomasz Słonina",
        instruments: ["trumpet", "vocal"],
        photo: "",
      },
      { name: "Nikola Skwarek", instruments: ["flute"], photo: "" },
      { name: "Nadia Firek", instruments: ["flute"], photo: "" },
      { name: "Milena Pelcel", instruments: ["flute"], photo: "" },
      { name: "Olga Lenart", instruments: ["flute"], photo: "" },
    ],
  },
  {
    name: "keyboardInstruments",
    members: [
      { name: "Maja Kornaś", instruments: ["piano"], photo: "" },
      { name: "Nina Mentel", instruments: ["synthesizer"], photo: "" },
    ],
  },
  {
    name: "rhythmSection",
    members: [
      {
        name: "Tomasz Lubaszka",
        instruments: ["drums", "percussion"],
        photo: "",
      },
      {
        name: "Krzysztof Trybuła",
        instruments: ["drums", "percussion"],
        photo: "",
      },
      {
        name: "Kacper Kędzior",
        instruments: ["electricGuitar", "acousticGuitar"],
        photo: "",
      },
      { name: "Przemysław Jurzec", instruments: ["bassGuitar"], photo: "" },
      {
        name: "Paweł Kulka",
        instruments: ["timpani", "percussion"],
        photo: "",
      },
      { name: "Hanna Lubaszka", instruments: ["cymbal"], photo: "" },
      { name: "Franciszek Grzybek", instruments: ["cymbal"], photo: "" },
    ],
  },
  {
    name: "vocalSoloists",
    members: [{ name: "Milena Filas", instruments: ["vocal"], photo: "" }],
  },
  {
    name: "choir",
    members: [
      { name: "Ksenia Miśkiewicz", instruments: ["vocal"], photo: "" },
      { name: "Justyna Strzelecka", instruments: ["vocal"], photo: "" },
      { name: "Ula Słonina", instruments: ["vocal"], photo: "" },
      { name: "Zofia Stankiewicz", instruments: ["vocal"], photo: "" },
      { name: "Maria Kowalcze", instruments: ["vocal"], photo: "" },
      { name: "Dominika Bury", instruments: ["vocal"], photo: "" },
      { name: "Ania Sporschill", instruments: ["vocal"], photo: "" },
      { name: "Aleksandra Białoń", instruments: ["vocal"], photo: "" },
      { name: "Aleksandra Karpiel", instruments: ["vocal"], photo: "" },
      { name: "Joanna Gwiżdż", instruments: ["vocal"], photo: "" },
      { name: "Emilia Janik", instruments: ["vocal"], photo: "" },
      {
        name: "Judyta Kwaśniewska",
        instruments: ["vocal"],
        photo: "",
      },
      { name: "Julia Błachut", instruments: ["vocal"], photo: "" },
      { name: "Julia Bielak", instruments: ["vocal"], photo: "" },
      { name: "Martyna Bałos", instruments: ["vocal"], photo: "" },
      { name: "Wojciech Jurzec", instruments: ["vocal"], photo: "" },
    ],
  },
];

const OrchestraMembersDisplay: React.FC = () => {
  const { t } = useTranslation();
  const imageRefs = useRef<{ [key: string]: HTMLImageElement | null }>({});

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const img = entry.target as HTMLImageElement;
          img.src = img.dataset.src!;
          observer.unobserve(img);
        }
      });
    });

    Object.values(imageRefs.current).forEach((img) => {
      if (img) {
        observer.observe(img);
      }
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div className={styles.sectionsContainer}>
      {orchestraSections.map((section, sectionIndex) => (
        <div key={section.name} className={styles.section}>
          <h2>{t(`musicians.sections.${section.name}`)}</h2>
          <div className={styles.membersGrid}>
            {section.members.map((member, memberIndex) => {
              const uniqueIndex = `${sectionIndex}-${memberIndex}`;
              return (
                <div key={uniqueIndex} className={styles.memberCard}>
                  {/* <div className={styles.photoWrapper}>
                    <img
                      ref={(el) => {
                        if (el) {
                          imageRefs.current[uniqueIndex] = el;
                        }
                      }}
                      src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                      data-src={member.photo}
                      alt={member.name}
                      className={styles.photo}
                    />
                  </div> */}
                  <div className={styles.memberInfo}>
                    <h3>{member.name}</h3>
                    {member.instruments.length > 0 && (
                      <p>
                        {member.instruments
                          .map((instrument) =>
                            t(`musicians.instruments.${instrument}`)
                          )
                          .join(", ")}
                      </p>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};

export default OrchestraMembersDisplay;
